The details of the webhook subscription to have its messages redelivered.
